
import {
    SET_CURRENT_FRAME,
    SET_CURRENT_DATA_INDEX, SET_TABLE_SELECT_CELL
} from './types';


export const setTable_selectCell = (lineNum ) =>async dispatch => {

    dispatch({
        type: SET_TABLE_SELECT_CELL,
        payload: lineNum
    });
};

export const set_current_frame = (current_frame ) =>async dispatch => {
    dispatch({
        type: SET_CURRENT_FRAME,
        payload: current_frame
    })
};

export const set_current_index = (currentDataIndex) =>async dispatch => {
    dispatch({
        type: SET_CURRENT_DATA_INDEX,
        payload: currentDataIndex
    })
};




// WEBPACK FOOTER //
// ./src/actions/frameActions.js